import { ActionTypeEnum, TButtonData, TCommonData, TSetFunc, TUseTriggerAction, TWAction, TWidget } from '@libs/types';
import React from 'react';
import { useSimpleInput } from '../../hooks/useInputs';
import { InputWrapper } from '../UI/Wrapper/InputWrapper';
import { PopupComponent } from '../UI/Popup/PopupComponent';
import { TextCommon } from '../UI/Text/TextCommon';
import { ButtonRowView } from './ButtonRowView';

type TButtonMessageBottomSheetProps = {
    initialValue: string;
    text?: string;
    buttonLabel?: string;
    maxLength?: number;
    uid: string;
    actions?: TWAction[];
    setPopup?: TSetFunc;
    setValue?: (value: string) => void;
    triggerAction: TUseTriggerAction<TButtonData>['triggerAction'];
};

enum ActionNameEnum {
    onAddMessage = 'onAddMessage',
}

export const ButtonMessageBottomSheet = ({
    initialValue,
    uid,
    text,
    buttonLabel,
    maxLength,
    triggerAction,
    actions,
    setPopup,
    setValue,
}: TButtonMessageBottomSheetProps) => {
    const { inputValue, isFocused, isFilled, handleBlur, handleFocus, handleChange } = useSimpleInput(initialValue);

    const handleClick = async () => {
        const action = actions?.find((a) => a?.name === ActionNameEnum.onAddMessage);
        try {
            if (!action) {
                return;
            }

            if (action.type === ActionTypeEnum.Player && setValue) {
                setValue(inputValue);
            } else {
                if (setValue) {
                    setValue(inputValue);
                }
                await triggerAction(action);
            }
        } catch (e) {
            console.error(`Widget ButtonMessageBottomSheet:${uid} catch error of fetch data:`, e);
        } finally {
            setPopup?.(null);
        }
    };
    return (
        <PopupComponent
            header={
                <>
                    <TextCommon
                        isWidget={false}
                        uid={`ButtonMessageBottomSheet_header_${uid}`}
                        as={'div'}
                        content={text ?? ''}
                        options={{ margin: { bottom: 32 } }}
                    />
                    <InputWrapper widget={{} as TWidget<TCommonData>} isFocused={isFocused} isFilled={isFilled} inputAlignCenter>
                        <input
                            autoFocus={true}
                            value={inputValue || ''}
                            data-test={`ButtonMessageBottomSheet_input_${uid}`}
                            type="text"
                            onChange={handleChange}
                            maxLength={maxLength}
                            onFocus={handleFocus}
                            onBlur={handleBlur}
                        />
                    </InputWrapper>
                </>
            }
            externalContent={[<ButtonRowView key={'done'} isDisabled={!inputValue} onClick={handleClick} label={buttonLabel ?? ''} iconName={'ic_check'} />]}
        />
    );
};
